import React from 'react';
import { ChartErrorBarAlt20 } from '@carbon/icons-react';
import type { Product } from '#config/products';
import LegacyAppLayout from '#coreComponents/LegacyAppLayout';
import PageQuery from '#core/PageQuery';
import type Products from '.';

const productPage = (productName: keyof typeof Products) => async () => {
  // this cannot be a param, dont try to make this function generic
  const products = (await import('.')).default;
  return {
    default: products[productName],
  };
};

const SelectScenario = React.lazy(productPage('SelectScenario'));
const SelectScenarioUpsell = React.lazy(productPage('SelectScenarioUpsell'));
const ScenarioDisabledUntilRelease = React.lazy(
  productPage('ScenarioDisabledUntilRelease'),
);
const CreateScenario = React.lazy(productPage('CreateScenario'));
const DuplicateScenario = React.lazy(productPage('DuplicateScenario'));
const ViewScenario = React.lazy(productPage('ViewScenario'));
const EditScenario = React.lazy(productPage('EditScenario'));

const exploreConfig: Product = {
  name: 'Explore',
  authKey: 'explore',
  description:
    'Understand how changes to your institution could impact your World University Ranking position by creating hypothetical scenarios',
  path: 'explore',
  icon: ChartErrorBarAlt20,
  color: 'electricViolet',
  disabledFeatureComponent: ScenarioDisabledUntilRelease,
  pageQuery: PageQuery,
  productConfig: {
    noChildren: true,
    useNonYearPermissions: true,
    topbar: {
      title: 'Explore',
      titleAcronym: 'Ex',
      rank: '1',
      filter: {
        hasPeerSelector: true,
        hasQueryBuilder: false,
      },
    },
  },
  pages: [
    {
      name: 'Select Scenario',
      path: 'select-scenario',
      component: SelectScenario,
      upsellComponent: SelectScenarioUpsell,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Create Scenario',
      path: 'create-scenario',
      component: CreateScenario,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Duplicate Scenario',
      path: 'duplicate-scenario/:scenarioId',
      component: DuplicateScenario,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'View Scenario',
      path: 'view-scenario/:scenarioId',
      component: ViewScenario,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
    {
      name: 'Edit Scenario',
      path: 'edit-scenario/:scenarioId',
      component: EditScenario,
      layout: LegacyAppLayout,
      pageConfig: {},
    },
  ],
};

export default exploreConfig;
